import { combineEpics } from 'redux-observable';
import {
  addClaimToSaisine,
  autofillApply,
  autofillPreview,
  createSaisine,
  deleteSaisine,
  generateSaisineDocs,
  removeClaimFromSaisine,
  retrieveSaisine,
  retrieveSaisines,
  searchEligibleClaims,
  validateSaisine,
} from './saisine.epics';

export const rootSaisineEpics = combineEpics(
  retrieveSaisines,
  retrieveSaisine,
  createSaisine,
  addClaimToSaisine,
  removeClaimFromSaisine,
  deleteSaisine,
  validateSaisine,
  searchEligibleClaims,
  generateSaisineDocs,
  autofillPreview,
  autofillApply,
);
